<template>
  <div>

    <xolas-table
    ref="permitsduetable"
    table-ref="permitsduetable"

    title="Permits"
    icon="fa fa-list"
    hide-org-badge
    :show-search="false"

    :url="'/permits/site/' + rowData.id"
    :fields="fields"

    />


  </div>

</template>

<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import {settings} from '@/components/Data'

import XolasTable from '@/components/atoms/tables/XolasTable'

export default {

mixins: [DateMixins, NumberMixins],

  components: {
    XolasTable
  },

props: {
  rowData: {
    type: Object,
    required: true
  }
},

  data () {
    return {
      // Per-column min-widths in content ratios so el-table flexes to fill (Type
      // wide enough for long permit names) instead of spreading equally; sum under
      // the table width — no h-scroll (XOL-231).
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'site_id',
          minWidth: '40'
        },
        {
          name: 'permitType',
          title: 'Type',
          sortField: 'permitType',
          minWidth: '170'
        },
        {
          name: 'applied',
          title: 'Applied',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '95'
        },
        {
          name: 'issued',
          title: 'Issued',
          callback: this.formatDate,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: '95'
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber,
          minWidth: '85'
        },
        {
          name: 'renewalPeriod',
          title: 'Period',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '80'
        },
        {
          name: 'ref1',
          title: settings.ref1Label,
          sortField: 'ref1',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '90'
        },
        {
          name: 'ref2',
          title: settings.ref2Label,
          sortField: 'ref2',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '85'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          titleClass: 'text-danger',
          dataClass: 'text-danger',
          callback: this.formatDate,
          minWidth: '90'
        }

    ]
  }
}
}

</script>
